import api from '../../api'

export default {
    async submit({ state, commit }, payload) {
        await api.bugs.submit(payload)
    }
}
